import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import zh from './locales/zh.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en },
    },
    fallbackLng: 'zh',
    supportedLngs: ['zh', 'en'],
    // LanguageDetector: check localStorage key 'daynote-lang', then navigator.language
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'daynote-lang',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;

/** Returns true when the active language is English */
export function isEnglish(): boolean {
  return i18n.language.startsWith('en');
}
